// extracted by mini-css-extract-plugin
export default {"header":"header_header__LL6UH","header_title":"header_header_title__TKZEk","header_duedate":"header_header_duedate__C2zTd"};